module.exports = __webpack_public_path__ + "img/ektp-logo.67c3ec3d.png";